import { Box } from '@mui/material';
import { type MRT_ColumnDef } from 'mantine-react-table';
import moment from 'moment-timezone';
import React, { useMemo } from 'react';
import { CustomChip } from '../../../../layout/styledcomponents/CustomChip';
import GenericTable, { LinkType } from '../../../shared/GenericTable';

const BillingReservationsList = (params: { data: any; invoiceId: number }) => {
    const { data, invoiceId } = params;

    const columns: MRT_ColumnDef<any>[] = [
        {
            accessorKey: 'moduleName',
            header: 'Experience',
            minSize: 220,
            size: 220,
            accessorFn: (row) => row.moduleName ?? row.module?.name,
        },
        {
            accessorKey: 'id',
            header: '#ID',
            minSize: 220,
            size: 220,
            accessorFn: (row) => `#${row.id}`,
        },
        {
            accessorKey: 'booker',
            header: 'Charge Type',
            minSize: 220,
            size: 220,
            Cell: ({ row }) => (
                <CustomChip
                    cursor='pointer'
                    label={
                        row.original?.booker
                            ? 'Reservation Charge'
                            : 'Additional Expense'
                    }
                    color={row.original?.booker ? 'blue' : 'yellow'}
                    variant='outlined'
                />
            ),
        },
        {
            accessorKey: 'startDate',
            header: 'Start Date',
            minSize: 100,
            size: 100,
            accessorFn: (row) =>
                row.startDate
                    ? moment(row.startDate).format('ll')
                    : row.date
                      ? moment(row.date).format('ll')
                      : 'N/A',
        },
        {
            accessorKey: 'endDate',
            header: 'End Date',
            minSize: 100,
            size: 100,
            accessorFn: (row) =>
                row.endDate
                    ? moment(row.endDate).format('ll')
                    : row.date
                      ? '-'
                      : 'N/A',
        },
        {
            accessorKey: 'bookedFor',
            header: 'For',
            minSize: 150,
            size: 150,
            accessorFn: (row) =>
                row.booker
                    ? `${row.booker.firstName} ${row.booker.lastName}`
                    : row.name
                      ? row.name
                      : 'N/A',
        },
        {
            accessorKey: 'bookedBy',
            header: 'Created By',
            minSize: 150,
            size: 150,
            accessorFn: (row) =>
                row.createdBy
                    ? `${row.createdBy.firstName} ${row.createdBy.lastName}`
                    : 'N/A',
        },
        {
            accessorKey: 'owner',
            header: 'Host',
            minSize: 150,
            size: 150,
            accessorFn: (row) => row.owner?.name ?? row.owner,
        },
    ];

    const processedData = useMemo(() => {
        if (!data) return [];
        return data.map((row: any) => ({
            ...row,
        }));
    }, [data]);

    const linkState = {
        name: 'BillingReservationsList',
        component: `Invoice #${invoiceId}`,
        url: `invoices/${invoiceId}`,
    };

    return (
        <Box sx={{ width: '100%', paddingTop: '20px' }}>
            <GenericTable
                columns={columns}
                data={processedData}
                tableName={`BillingReservationsList`}
                loading={!data}
                linkType={LinkType.Reservation}
                linkState={linkState}
            />
        </Box>
    );
};

export default BillingReservationsList;
